import { render, staticRenderFns } from "./wxviscerachart.vue?vue&type=template&id=d56986b2&scoped=true&"
import script from "./wxviscerachart.vue?vue&type=script&lang=js&"
export * from "./wxviscerachart.vue?vue&type=script&lang=js&"
import style0 from "./wxviscerachart.vue?vue&type=style&index=0&id=d56986b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56986b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d56986b2')) {
      api.createRecord('d56986b2', component.options)
    } else {
      api.reload('d56986b2', component.options)
    }
    module.hot.accept("./wxviscerachart.vue?vue&type=template&id=d56986b2&scoped=true&", function () {
      api.rerender('d56986b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxviscerachart.vue"
export default component.exports